import ShimmerWrapper from "@stadium/ui/src/components/loaders/shimmer-wrapper";
import ShadowCard from "@sharedComponents/cards/shadow-card";

import styles from "../main.module.scss";

type ListingLoaderProps = {
  showLeftPanel: boolean;
};

export default function ListingLoader({ showLeftPanel }: ListingLoaderProps) {
  return (
    <ShimmerWrapper
      length={showLeftPanel ? 8 : 10}
      cardClass={styles.colCard}
      wrapperClass={`${styles.rowWrapper} ${
        showLeftPanel ? styles.productCardsWrapper : styles.productCardsWrapperFive
      }`}
    >
      <ShadowCard />
    </ShimmerWrapper>
  );
}
